module.exports = __webpack_public_path__ + "8d744cccaf04c644ea9bf4782617ee12.png";